import type {ClContract} from "./contractLinkageData";
import type {ClReviewTx} from "./contractLinkageUtils";
import {BASIS_LABEL, CHANNEL_LABEL, STATUS_LABEL} from "./contractLinkageUtils";

const esc = (v: string | number | null | undefined): string => {
    const s = v === null || v === undefined ? '' : String(v);
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export function exportContractLinkageCsv(
    rows: ClReviewTx[],
    contractsById: ReadonlyMap<string, ClContract>,
) {
    const header = [
        'Transaction', 'Document', 'Supplier', 'Source', 'Invoice date', 'Posting date', 'Clearing date',
        'Amount', 'Entity', 'Cost centre', 'Category',
        'AI contract', 'Effective contract', 'Match basis', 'Confidence', 'Review status',
    ];
    const lines = rows.map(tx => [
        esc(tx.description),
        esc(tx.docNumber),
        esc(tx.supplier),
        esc(tx.channel ? CHANNEL_LABEL[tx.channel] : 'Direct invoice'),
        esc(tx.date),
        esc(tx.postingDate),
        esc(tx.clearingDate ?? ''),
        esc(tx.amount),
        esc(tx.entity),
        esc(tx.costCenter),
        esc(tx.category),
        esc(tx.aiContractId ? contractsById.get(tx.aiContractId)?.name ?? tx.aiContractId : ''),
        esc(tx.effectiveContractName ?? ''),
        esc(tx.basis ? BASIS_LABEL[tx.basis] : ''),
        esc(tx.aiContractId ? tx.confidence : ''),
        esc(STATUS_LABEL[tx.status]),
    ].join(','));

    const csv = [header.join(','), ...lines].join('\n');
    const blob = new Blob([csv], {type: 'text/csv;charset=utf-8;'});
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'contract-linkage-review.csv';
    a.click();
    URL.revokeObjectURL(url);
}
